var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgressFiveGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 72,
    viewBox: "0 0 32 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 31,
    rx: 15.5,
    fill: "#575757"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7891 21.1875C13.6328 21.1875 12.0938 19.8438 11.9297 18.0078L11.9219 17.9219H13.3047L13.3125 17.9844C13.4531 19.1016 14.4531 19.9531 15.8047 19.9531C17.3359 19.9531 18.3984 18.8906 18.3984 17.375V17.3594C18.3906 15.875 17.3203 14.8125 15.8281 14.8125C15.0625 14.8125 14.4062 15.0391 13.9062 15.4922C13.7031 15.6797 13.5234 15.8984 13.375 16.1562H12.1328L12.7109 9.72656H19.1641V10.9766H13.8672L13.4844 14.7656H13.5156C14.0469 14.0078 14.9844 13.6016 16.0781 13.6016C18.2422 13.6016 19.8047 15.1719 19.8047 17.3359V17.3516C19.7969 19.6094 18.1328 21.1875 15.7891 21.1875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 72L16.5 31",
    stroke: "#575757",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressFiveGrey);
export default __webpack_public_path__ + "static/media/progressFiveGrey.5aa61b576a7279d301ecfc489e43596a.svg";
export { ForwardRef as ReactComponent };